import React from 'react';

function getBorderStyles(variant, side) {
    let borderColor = 'border-black';
    switch (variant) {
        case 'minimal':
            return '';
        case 'borderLight':
            borderColor = 'border-gray-300';
            return side ? `border-${side} ${borderColor}` : `border ${borderColor}`;
        default:
            return side
                ? `border-${side}-2  ${borderColor}`
                : `border-2 border-black`;
    }
}
const TableCell = ({ align = 'left', children, className = '', header, ...props }) => {
    const Component = header ? 'th' : 'td';
    return (React.createElement(Component, { className: [`text-${align}`, header ? 'font-medium' : '', className].join(' '), ...props }, children));
};
const TableRow = ({ children, className = '', header, hover, ...props }) => {
    return (React.createElement("tr", { className: [hover ? 'hover:bg-gray-100' : '', className].join(' '), ...props }, React.Children.map(children, (child) => React.cloneElement(child, header
        ? {
            header: true,
        }
        : {}))));
};
const TableHead = ({ children, className, variant = 'border', ...props }) => {
    return (React.createElement("thead", { className: [getBorderStyles(variant, 'b'), className].join(' '), ...props }, React.Children.map(children, (child) => React.cloneElement(child, {
        header: true,
    }))));
};
const TableBody = ({ children, hover, ...props }) => {
    return (React.createElement("tbody", { ...props }, React.Children.map(children, (child) => React.cloneElement(child, {
        hover,
    }))));
};
const TableFooter = ({ children, className, variant = 'border', ...props }) => {
    return (React.createElement("tfoot", { className: [getBorderStyles(variant, 't'), className].join(' '), ...props }, children));
};
const Table = ({ children, className = '', fixedWidth, variant = 'minimal', ...props }) => {
    return (React.createElement("table", { className: [
            getBorderStyles(variant),
            'border-collapse w-full text-left',
            fixedWidth ? 'table-fixed' : '',
            className,
        ].join(' '), ...props }, children));
};

export { Table, TableBody, TableCell, TableFooter, TableHead, TableRow };
//# sourceMappingURL=Table.js.map
